import { removeEmpty } from "./objects";

export const getQuery = (params) =>
  new URLSearchParams(removeEmpty(params)).toString();
